<app-admin-form [title]="'Menu instellingen'" [object]="settings">

  <app-admin-custom-control>
    <div cdkDropListGroup>
      <app-admin-shop-module-menu [menu]="settings.MenuItems" [settings]="settings" (changed)="reIndex($event)"></app-admin-shop-module-menu>
    </div>
  </app-admin-custom-control>

  <app-admin-cancel-save-button [saveAction]="adminSettingsService.saveSettingsMenu(settings)"></app-admin-cancel-save-button>
</app-admin-form>